export const translations = {
    RU: {
        'APPHEADER_TITLE': 'Корона СТОП',

        'SIDEMENU_ITEM_JOURNAL': 'Дневник',
        'SIDEMENU_ITEM_DOCTORDLIST': 'Список врачей',
        'SIDEMENU_ITEM_LANGUAGE': 'Язык',
        'APPHEADER_CHECK_BUTTON': "RU"

    },
    EN: {
        'APPHEADER_TITLE': 'Corona STOP',

        'SIDEMENU_ITEM_JOURNAL': 'Journal',
        'SIDEMENU_ITEM_DOCTORDLIST': 'List of doctors',
        'SIDEMENU_ITEM_LANGUAGE': 'Language',
        'APPHEADER_CHECK_BUTTON': "EN"
    }
};
